import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { AggregationBucket } from '../models/dashboard/aggregation-bucket';
import { List } from 'immutable';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../http/app.auth.http.service';

@Injectable()
export class DashboardTotalsHttpService {
  private aggregateBaseURL =  '/api/events/dashboard';
  private missingAgencyCountURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/missing-agency';
  private completeAndUnpaidCountURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/complete-and-unpaid';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  getCompletedAndUnpaidCounts(): Observable<List<AggregationBucket>> {
    return this.http.get(this.completeAndUnpaidCountURL)
      .map(res => List<AggregationBucket>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getMissingAgencyCount(): Observable<number> {
    return this.http.get(this.missingAgencyCountURL)
      .map(response => Number(response.text()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/dashboard-totals.http.service.ts